import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
// Temporarily disabled for development to avoid refresh loops
// serviceWorkerRegistration.register({
//   onSuccess: () => console.log('💜 Belong is ready for offline use!'),
//   onUpdate: (registration) => {
//     console.log('New version available! Please refresh.');
//     // Optionally show a notification to the user
//     if (window.confirm('New version available! Refresh to update?')) {
//       window.location.reload();
//     }
//   }
// });

// Unregister service worker for development
serviceWorkerRegistration.unregister();
